"use strict";

exports.__esModule = true;
exports.DateCellType = exports.CELL_TYPE = void 0;
var _dateType = require("./dateType");
exports.CELL_TYPE = _dateType.CELL_TYPE;
exports.DateCellType = _dateType.DateCellType;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/cellTypes/dateType/index.js
// module id = 1096
// module chunks = 0